<div class="p-[36px] bg-surface-background text-support-text">
  <div class="font-termina text-[32px]">Add User</div>

  <div class="bg-base-100 h-[4px] w-full rounded-[4px] my-[25px]"></div>

  <div class="mb-[30px]">
    <div class="px-[22px] font-montserrat font-semibold">First Name</div>
    <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
      <input [formControl]="newUserForm.controls.firstName" class="w-full p-2 pl-4" placeholder="First Name*" />
    </div>
  </div>

  <div class="mb-[30px]">
    <div class="px-[22px] font-montserrat font-semibold">Last Name</div>
    <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
      <input [formControl]="newUserForm.controls.lastName" class="w-full p-2 pl-4" placeholder="Last Name*" />
    </div>
  </div>

  <div class="mb-[30px]">
    <div class="px-[22px] font-montserrat font-semibold">Email</div>
    <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
      <input [formControl]="newUserForm.controls.email" class="w-full p-2 pl-4" placeholder="Email*" />
    </div>
  </div>

  <div class="mb-[30px]">
    <div class="px-[22px] font-montserrat font-semibold">Mobile Number</div>
    <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
      <input [formControl]="newUserForm.controls.mobile" class="w-full p-2 pl-4" placeholder="Mobile Number" />
    </div>
  </div>

  <div class="flex items-center justify-center w-full">
    <button matRipple [disabled]="newUserForm.invalid || submitting" (click)="createNewUser()" class="flex gap-4 items-center disabled:bg-opacity-30 disabled:text-opacity-30 font-termina bg-green-primary text-green-secondary text-[20px] text-center rounded-[5px] py-[13px] px-[25px] m-auto">
      @if (submitting) {
        <svg class="animate-spin" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="COCO/Line/Rotate - Right"><path id="Vector" d="M21.5059 12.7058C21.5059 17.5921 17.4764 21.5532 12.5059 21.5532C7.5353 21.5532 3.50586 17.5921 3.50586 12.7058C3.50586 7.81945 7.50586 3.8583 12.5059 3.8583C18.5059 3.8583 21.5059 8.77356 21.5059 8.77356M21.5059 8.77356L21.5059 3.55322M21.5059 8.77356H16.8508" class="opacity-30 stroke-green-secondary group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>
        </svg>
      }
      <span>{{ submitting ? 'Submitting' : 'Add User' }}</span>
    </button>
  </div>
</div>
